import React from "react";
import {
  FaProjectDiagram,
  FaPeopleCarry,
  FaServicestack,
  FaBullseye,
} from "react-icons/fa";
export default class OurValues extends React.Component {
  componentDidMount() {
    const $ = window.$;

    if ($(".odometer").length) {
      var odo = $(".odometer");
      odo.each(function () {
        $(this).appear(function () {
          var countNumber = $(this).attr("data-count");
          $(this).html(countNumber);
        });
      });
    }
  }
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <>
        <section className="counter-one">
          <div
            className="counter-one-bg jarallax"
            data-jarallax
            data-speed="0.2"
            data-imgPosition="50% 0%"
          ></div>
          <div className="container">
            <div className="section-title text-center">
              <span className="section-title__tagline" style={{color:"lightgray"}}>Our Values</span>
              <h2 className="section-title__title">
                Excellence through creativity, service, <br /> partnerships, and
                cultural understanding
              </h2>
            </div>
            <div className="row">
              <div
                className="col-xl-3 col-lg-6 col-md-6 wow fadeInLeft"
                data-wow-delay="300ms"
              >
                {/* Counter One Single */}
                <div className="counter-one__single">
                  <div className="counter-one__content">
                    <div className="help-one__single">
                      <div className="help-one__icon">
                        <span>
                          <FaBullseye fontSize={"32px"} />
                        </span>
                      </div>

                      <div className="help-one__content">
                        <h4>Cultural Sensitivity and Awareness</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-3 col-lg-6 col-md-6 wow fadeInLeft"
                data-wow-delay="100ms"
              >
                {/* Counter One Single */}
                <div className="counter-one__single">
                  <div className="counter-one__content">
                    <div className="help-one__single">
                      <div className="help-one__icon">
                        <span>
                          <FaProjectDiagram fontSize={"32px"} />
                        </span>
                      </div>

                      <div className="help-one__content">
                        <h4>Creativity and Innovation</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-3 col-lg-6 col-md-6 wow fadeInLeft"
                data-wow-delay="200ms"
              >
                {/* Counter One Single */}
                <div className="counter-one__single">
                  <div className="counter-one__content">
                    <div className="help-one__single">
                      <div className="help-one__icon">
                        <span>
                          <FaPeopleCarry fontSize={"32px"} />
                        </span>
                      </div>

                      <div className="help-one__content">
                        <h4>Strategic Partnerships</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-3 col-lg-6 col-md-6 wow fadeInLeft"
                data-wow-delay="400ms"
              >
                {/* Counter One Single */}
                <div className="counter-one__single">
                  <div className="counter-one__content">
                    <div className="help-one__single">
                      <div className="help-one__icon">
                        <span>
                          <FaServicestack fontSize={"32px"} />
                        </span>
                      </div>

                      <div className="help-one__content">
                        <h4>Exceptional Service Delivery</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
